import { deleteApi, getApi, getApiPDF, postApi } from 'apis';
const uploadImage = async (data: any) => {
	return await postApi('/company/company-logo', data, true);
};

const getCompanyDetails = async () => {
	return await getApi('/company/details');
};

const getFinancialYear = async () => {
	return await getApi('/company/financial-year');
};

const verifyAccountApi = async (data: any) => {
	return await postApi('/bank-details/inquiry', data);
};

const getBankDetails = async () => {
	return await getApi('/company/bank-details');
};

const getCompanyLogo = async () => {
	return await getApiPDF('/company/company-logo');
};

const verifyStanbicDetails = async (companyId: string) => {
	return await postApi(`/bank-details/verify`, {
		companyId,
	});
};

const deleteCompanyLogo = async () => {
	return await deleteApi('/company/company-logo');
};

const verifyIzbAccountApi = async (data: {
	accountNumber: string;
	branchCode: string;
}) => {
	return await postApi('/bank-details/izb-verify-account', data);
};

const saveIzbDetails = async (data: {
	// Only the changed fields; the server keeps the rest.
	izbDetails: { apiKey?: string; username?: string; password?: string };
}) => {
	return await postApi('/company/izb-details', data);
};

export const companySetup = {
	getCompanyDetails,
	getFinancialYear,
	verifyAccountApi,
	getBankDetails,
	uploadImage,
	getCompanyLogo,
	verifyStanbicDetails,
	deleteCompanyLogo,
	verifyIzbAccountApi,
	saveIzbDetails,
};
